// utils/decodeHtml.ts

/**
 * Decodes a string containing HTML entities (e.g. &amp;, &#039;) into plain text.
 *
 * @param {string} input - The encoded string.
 * @returns {string} - Decoded plain text.
 */
export function decodeHtml(input: string): string {
	const doc = new DOMParser().parseFromString(input, 'text/html');
	return doc.documentElement.textContent ?? input;
}
